import { OrdenCompra, DocumentoCabAlmacen } from "./documentos-general.model";

export class CotizacionModel {

   fechaEmision: string = '';
   tipCambio: number = 0;
   tipocambio: any;
   codMotivo: number = 1;
   IGV: any = 18;
   IncIgv: string = 'true';
   codSerie: string;
   numero: number = 0;
   codInterlocutor: string = '';
   desInterlocutor: string = '';
   marca: string = '';
   tipoDocumento: string = ''; //tident
   documento: string = ''; //dident
   razonSocial: string = '';
   coddireccion: number = null;
   direccion: string = '';
   plazoEntrega: string = '';
   codigoContacto: number = null;
   contacto: string = '';
   emailContacto: string = '';
   validez: string = '';
   comentario: string = '';
   codMoneda: string = 'PEN';
   moneda: string = 'Soles';
   simbolo: string = 'S/.';
   referencia: string = '';
   ordenCompra = new OrdenCompra;
   direccionEnvio = new DocumentoCabAlmacen;
   codVendedor: number;
   vendedor: string = '';
   codCondicionPago: number = null;
   CondicionPago: string = '';
   // public codDireccionEnvio: number = null;
   // public desDireccionEnvio: string = '';
   codTransportista: number = null;
   desTransportista: string = '';
   observacion: string = '';

   //VARIABLES TOTALES
   monexo: number = 0;
   monina: number = 0;
   descue: number = 0;
   valvent: number = 0;
   monisc: number = 0;
   monigv: number = 0;
   monotr: number = 0;
   montri: number = 0;
   monant: number = 0;
   importe: number = 0;

   //Saldo cliente 
   tipoCredito: string = 'Disponible';
   simboloSaldo: string = 'S/.';
   limiteCredito: number = 0;
   saldo: number = 0;
}

export class  objDocumentoRelacion {

   id_cia : number;
   numint : number;
   tipdoc : number;
   series : string;
   numdoc : number;
   femisi : string;
   numintre : number;
 /* trasients */
   tipdocre : number;
}
export class prueba{
   numint?:any= 0;
   situacNombre ?:any = '';
   serie ?:any = '';
   numero ?:any = 0;
   femisi ?:any = '';
   razonsocial ?:any = '';
   moneda ?:any = '';
   monina ?:any = 0;
   monafe ?:any = 0;
   monigv ?:any = 0;
   preven ?:any = 0;
   fcreac ?:any = new Date();
   factua ?:any = new Date();
   ucreac ?:any = '';
   usuari ?:any ='';
}